module.exports = __webpack_public_path__ + "img/03.df0975e9.png";